import React, { useEffect } from 'react';

import registerAnimations from './registerAnimations';

import quote from './../../static/images/merinowool/quote.png';

import staticBgSec8 from './../../static/images/merinowool/bg-sec8.jpg';
import staticBgSec8Mobile from './../../static/images/merinowool/bg-sec8-sm.jpg';
import staticBgSec10 from './../../static/images/merinowool/bg-sec10.jpg';
import staticBgSec10Mobile from './../../static/images/merinowool/bg-sec10-sm.jpg';
import staticBgSec11 from './../../static/images/merinowool/bg-sec11.jpg';
import staticBgSec11Mobile from './../../static/images/merinowool/bg-sec11-sm.jpg';
import staticBgSec12 from './../../static/images/merinowool/bg-sec12.jpg';
import staticBgSec12Mobile from './../../static/images/merinowool/bg-sec12-sm.jpg';
import staticShoeDotsImage from './../../static/images/merinowool/shoe-sole.jpg';
import staticTestimonialShoeImage from './../../static/images/merinowool/shoe-yellow-2.jpg';
import TrustpilotWidget from '../TrustpilotWidget/TrustpilotWidget';

const MerinoWool2 = (props) => {

  const {
    bgSec8,
    bgSec8Mobile,
    bgSec10,
    bgSec10Mobile,
    bgSec11,
    bgSec11Mobile,
    bgSec12,
    bgSec12Mobile,

    regulateFootTemperatureText,
    regulateFootTemperatureButton1Text,
    regulateFootTemperatureButton2Text,
    regulateFootTemperatureButton1Url,
    regulateFootTemperatureButton2Url,

    shoeDotsText,
    shoeDotsButton1Text,
    shoeDotsButton2Text,
    shoeDotsButton1Url,
    shoeDotsButton2Url,
    shoeDotsDotText1,
    shoeDotsDotText2,
    shoeDotsDotText3,
    shoeDotsImage,

    footBedText,
    easyCleaningText,
    sheepText, 
    sheepButtonUrl,
    sheepButtonText,

    testimonialShoeImage,
    testimonialText,
    testimonialButton1Url,
    testimonialButton1Text,
    testimonialButton2Url,
    testimonialButton2Text,
  } = props;

  useEffect(() => {
    registerAnimations();
  }, [])

  return (
    <div className="landingpage-merinowool">

      <style>
        {`
          .sec8 {
            background-image: url(${bgSec8Mobile});
          }

          @media (min-width: 768px) {
            .sec8 {
              background-image: url(${bgSec8});
            }
          }
        `}
      </style>

      <section className="sec sec8">
        <div className="container">
          <div className="row">
            <article className="content col-12 col-md-7 col-lg-6 col-xl-5 mb-5 mb-lg-0 ml-md-auto">
              {regulateFootTemperatureText}
              <p className="mt-5 row compact btn-cont">
                <span className="col-6"><a href={regulateFootTemperatureButton1Url} className="btn btn-outline-light btn-block mb-3">{regulateFootTemperatureButton1Text}</a></span>
                <span className="col-6"><a href={regulateFootTemperatureButton2Url} className="btn btn-outline-light btn-block  mb-3">{regulateFootTemperatureButton2Text}</a></span>
              </p>
            </article>
          </div>
        </div>
      </section>
      <section className="sec sec9">
        <div className="container">
          <div className="row">
            <article className="content-2 col-12 col-md-6 col-lg-6 col-xl-6  mb-lg-0">
              {shoeDotsText}
              <p className="mt-5 row compact d-none d-md-block btn-cont">
                <span className="col-6"><a href={shoeDotsButton1Url} className="btn btn-dark btn-block mb-3">{shoeDotsButton1Text}</a></span>
                <span className="col-6"><a href={shoeDotsButton2Url} className="btn btn-dark btn-block  mb-3">{shoeDotsButton2Text}</a></span>
              </p>
            </article>
            <div className="col-12 col-md-6 col-lg-6 col-xl-6">
              <div className="sole-features-cont clearfix">
                <p className="shoe-sole"><img src={shoeDotsImage} alt="" /></p>
                <ul className="sole-features">
                  <li><em><span>{shoeDotsDotText1}</span></em></li>
                  <li><em><span>{shoeDotsDotText2}</span></em></li>
                  <li><em><span>{shoeDotsDotText3}</span></em></li>
                </ul>
              </div>
            </div>
          </div>
          <p className="mt-5 row compact d-md-none btn-cont">
            <span className="col-6"><a href={shoeDotsButton1Url} className="btn btn-dark btn-block mb-3">{shoeDotsButton1Text}</a></span>
            <span className="col-6"><a href={shoeDotsButton2Url} className="btn btn-dark btn-block  mb-3">{shoeDotsButton2Text}</a></span>
          </p>
        </div>
      </section>

      <style>
        {`
          .sec10:before {
            background:url(${bgSec10Mobile}) no-repeat 50% 0;
          }

          @media (min-width: 768px) {
            .sec10:before{
              background-image: url(${bgSec10});
            }
          }
        `}
      </style>

      <section className="sec sec10">
        <div className="container">
          <div className="row">
            <article className="content-2 col-12 col-md-6 col-lg-6 col-xl-5  mb-lg-0 ml-md-auto">
              {footBedText}
            </article>
          </div>
        </div>
      </section>

      <style>
        {`
          .sec11 {
            background-image:url(${bgSec11Mobile});
          }

          @media (min-width: 768px) {
            .sec11 {
              background-image: url(${bgSec11});
            }
          }
        `}
      </style>

      <section className="sec sec11">
        <div className="container">
          <div className="row">
            <article className="content col-10 col-md-6 col-lg-5 col-xl-4  mb-lg-0">
              {easyCleaningText}
            </article>
          </div>
        </div>
      </section>

      <style>
        {`
          .sec12 {
            background:url(${bgSec12Mobile});
          }

          @media (min-width: 768px) {
            .sec12 {
              background-image: url(${bgSec12});
            }
          }
        `}
      </style>

      <section className="sec sec12">
        <div className="container">
          <div className="row">
            <article className="content col-11 col-md-6 col-lg-5 col-xl-4  mb-lg-0 ml-md-auto">
              {sheepText}
              <p className="d-none d-lg-block pt-3"><a href={sheepButtonUrl} className="btn btn-outline-light">{sheepButtonText}</a></p>
            </article>
          </div>
        </div>
      </section>
      <section className="sec py-5 testimonials">
        <div className="container">
          <p className="text-center qoute pb-4"><img src={quote} alt="" /></p>
        </div>
        <div className="trustBox-widget py-4 py-lg-5 mb-5">
          <div className="container">
            <TrustpilotWidget />
          </div>
        </div>
        <div className="testimonials-products">
          <div className="container">
            <div className="row">
              <figure className="d-none d-md-block col-12 col-md-5">
                <p><img src={testimonialShoeImage} alt="" /></p>
              </figure>
              <article className="content col-12 col-md-7 mb-lg-0 ml-md-auto">
                {testimonialText}
                <figure className="d-md-none"><img src={testimonialShoeImage} alt="" /></figure>
                <p className="mt-5 row compact btn-cont">
                  <span className="col-6"><a href={testimonialButton1Url} className="btn btn-dark btn-block d-md-inline-block mb-3">{testimonialButton1Text}</a></span>
                  <span className="col-6"><a href={testimonialButton2Url} className="btn btn-dark btn-block d-md-inline-block mb-3">{testimonialButton2Text}</a></span>
                </p>
              </article>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

MerinoWool2.defaultProps = {
  bgSec8: staticBgSec8,
  bgSec8Mobile: staticBgSec8Mobile,
  bgSec10: staticBgSec10,
  bgSec10Mobile: staticBgSec10Mobile,
  bgSec11: staticBgSec11,
  bgSec11Mobile: staticBgSec11Mobile,
  bgSec12: staticBgSec12,
  bgSec12Mobile: staticBgSec12Mobile,

  regulateFootTemperatureText: <>
      <h2><strong>MERINO WOOL.</strong> <br /> REGULATES FOOT TEMPERATURE!</h2>
      <p>
        In addition to all-day-long comfort, Merino wool keep your feet cool even in warm temperatures…and, when the temperatures start to get cold again, Merino wool will keep your feet cozy and warm. Now that’s a multi-talented fabric!
      </p>
    </>,
  regulateFootTemperatureButton1Text: 'WOMEN',
  regulateFootTemperatureButton2Text: 'MEN',
  regulateFootTemperatureButton1Url: '#',
  regulateFootTemperatureButton2Url: '#',

  shoeDotsText: <>
    <h2>A WELL-GROUNDED<br /><strong>SOLE SYSTEM</strong></h2>
    <p>Three special components make our sole system unique. Firstly, our super-light and flexible EVA material makes walking a breeze. Secondly, the heel section is wonderfully comfortable—and thirdly, the shoe’s profile is defined by our sophisticated Diamond-System, which guarantees a slip-free grip and stable hold.</p>
  </>,
  shoeDotsButton1Text: 'WOMEN',
  shoeDotsButton2Text: 'MEN',
  shoeDotsButton1Url: '#',
  shoeDotsButton2Url: '#',
  shoeDotsDotText1: 'The shoe’s profile is defined by our sophisticated Diamond-System',
  shoeDotsDotText2: 'Super-light and flexible EVA material',
  shoeDotsDotText3: 'The heel section is wonderfully comfortable',
  shoeDotsImage: staticShoeDotsImage,

  footBedText: <>
    <h2>INTERCHANGEABLE <br /> <strong>FOOTBED</strong></h2>
    <p>A performance footbed with an all-day shock-absorbing effect. Made of soft Merino wool.</p>
  </>,
  easyCleaningText: <>
    <h2><strong>MACHINE   WASHABLE </strong> <br /> AND EASY TO  CARE FOR</h2>
    <p>You can wash your Merino Wool Knit in the washing machine (cold water, delicate wash cycle, no fabric softener; please remove the shoe’s insole before washing.) After washing, simple let your shoes air dry  (don’t put them into  the dryer) and they’ll  be as good as new.</p>
  </>,
  sheepText: <>
    <h2><strong>Green</strong> <br /> Strategy</h2>
    <p>Throughout the three generations of our company’s family owned and operated business, we’ve learned to combine our knowledge of wool craftsmanship with modern, green thinking about the environment and animal protection</p>
  </>,
  sheepButtonText: 'KNOW MORE',
  sheepButtonUrl: '#',

  testimonialShoeImage: staticTestimonialShoeImage,
  testimonialText: <>
    <h3><strong>These Clients bought this shoe, </strong>  Maybe try this one too</h3>
  </>,
  testimonialButton1Text: 'WOMEN',
  testimonialButton2Text: 'MEND',
  testimonialButton1Url: '#',
  testimonialButton2Url: '#',
}

export default  MerinoWool2;